/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function GlobeJuicyIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="globe-juicy"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <circle cx={12} cy={12} r={9.5} stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M12 21.5A14.643 14.643 0 0 1 12 2.5" data-tinysvg-shape="arc" data-tinysvg-arc="23.143 12 14.643 14.643 139.551 220.449 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M12 2.5A14.643 14.643 0 0 1 12 21.5" data-tinysvg-shape="arc" data-tinysvg-arc="0.857 12 14.643 14.643 319.551 400.449 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M21.281 12A23.046 23.046 0 0 1 2.5 12" data-tinysvg-shape="arc" data-tinysvg-arc="11.891 -9.046 23.046 23.046 65.953 114.047 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
    </svg>
  )
}
